declare var moment: any;
declare var $: any;

export default class DateRangePicker {
  private $datePicker: HTMLElement;
  private isInitialized: boolean = false;
  private domModified: boolean = false;
  private datePicker: any;
  private selector: string;

  private $drawerInputDateStartShadow: HTMLInputElement;
  private $drawerInputTimeStartShadow: HTMLInputElement;
  private $drawerInputDateEndShadow: HTMLInputElement;
  private $drawerInputTimeEndShadow: HTMLInputElement;
  private $drawerInputDateStart: HTMLInputElement;
  private $drawerInputTimeStart: HTMLInputElement;
  private $drawerInputDateEnd: HTMLInputElement;
  private $drawerInputTimeEnd: HTMLInputElement;
  private $drawerSubmitButton: HTMLElement;
  private $drawerCloseButton: HTMLElement;
  private $drawerForm: HTMLFormElement;
  private $drawer: HTMLElement;

  private $pickerInputDateStart: HTMLInputElement;
  private $pickerInputTimeStart: HTMLInputElement;
  private $pickerInputDateEnd: HTMLInputElement;
  private $pickerInputTimeEnd: HTMLInputElement;
  private $button: HTMLElement;

  private $inputDateStart: HTMLInputElement;
  private $inputTimeStart: HTMLInputElement;
  private $inputDateEnd: HTMLInputElement;
  private $inputTimeEnd: HTMLInputElement;

  constructor(selector: string) {
    this.selector = selector;
    this.$button = document.querySelector(this.selector);

    this.$drawer = document.querySelector('.tc-form-drawer.is-date-range-drawer');
    this.$drawerInputDateStart = this.$drawer.querySelector('.tc-date-range-drawer-start .tc-date-input');
    this.$drawerInputTimeStart = this.$drawer.querySelector('.tc-date-range-drawer-start .tc-time-input');
    this.$drawerInputDateEnd = this.$drawer.querySelector('.tc-date-range-drawer-end .tc-date-input');
    this.$drawerInputTimeEnd = this.$drawer.querySelector('.tc-date-range-drawer-end .tc-time-input');
    this.$drawerSubmitButton = this.$drawer.querySelector('.tc-form-drawer__submit');
    this.$drawerCloseButton = this.$drawer.querySelector('.tc-form-drawer__close');
    this.$drawerForm = this.$drawer.querySelector('form');

    this.$drawerInputDateStartShadow = document.querySelector(this.$drawerInputDateStart.getAttribute('data-shadow-input'));
    this.$drawerInputTimeStartShadow = document.querySelector(this.$drawerInputTimeStart.getAttribute('data-shadow-input'));
    this.$drawerInputDateEndShadow = document.querySelector(this.$drawerInputDateEnd.getAttribute('data-shadow-input'));
    this.$drawerInputTimeEndShadow = document.querySelector(this.$drawerInputTimeEnd.getAttribute('data-shadow-input'));

    this.$inputDateStart = document.querySelector('.tc-shipment-date-start');
    this.$inputTimeStart = document.querySelector('.tc-shipment-time-start');
    this.$inputDateEnd = document.querySelector('.tc-shipment-date-end');
    this.$inputTimeEnd = document.querySelector('.tc-shipment-time-end');

    document.querySelector(this.selector).addEventListener('click', () => this.onButtonClicked());

    this.$drawerSubmitButton.addEventListener('click', (event) => this.onDrawerSubmitButtonClicked(event));
    this.$drawerCloseButton.addEventListener('click', (event) => this.onDrawerCloseButtonClicked(event));

    window.addEventListener('resize', () => this.onWindowResize());

    if (window.innerWidth >= 1200) {
      this.initialize();
    }
  }

  private initialize(): void {
    this.isInitialized = true;

    let startDate = moment().startOf('day');
    let endDate = moment().endOf('day');

    if (this.$inputDateStart.value.length) {
      const [ day, month, year ] = this.$inputDateStart.value.split('/');

      startDate.set({
        month: parseInt(month) - 1,
        year: parseInt(year),
        date: parseInt(day),
      });
    }

    if (this.$inputTimeStart.value.length) {
      const [ hour, minute ] = this.$inputTimeStart.value.split(':');

      startDate.set({
        minute: parseInt(minute),
        hour: parseInt(hour),
      });
    }

    if (this.$inputDateEnd.value.length) {
      const [ day, month, year ] = this.$inputDateEnd.value.split('/');

      endDate.set({
        month: parseInt(month) - 1,
        year: parseInt(year),
        date: parseInt(day),
      });
    }

    if (this.$inputTimeEnd.value.length) {
      const [ hour, minute ] = this.$inputTimeEnd.value.split(':');

      endDate.set({
        minute: parseInt(minute),
        hour: parseInt(hour),
      });
    }

    $(this.selector).daterangepicker({
      showCustomRangeLabel: false,
      alwaysShowCalendars: true,
      autoApply: true,
      startDate,
      endDate,
      locale: {
        daysOfWeek: [
          'S',
          'M',
          'T',
          'W',
          'T',
          'F',
          'S',
        ],
        monthNames: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
      },
      ranges: {
        'Today': [
          moment().startOf('day'),
          moment().endOf('day'),
        ],
        'This week': [
          moment().startOf('week'),
          moment().endOf('week'),
        ],
        'This month': [
          moment().startOf('month'),
          moment().endOf('month'),
        ],
        'This year': [
          moment().startOf('year'),
          moment().endOf('year'),
        ],
      },
      opens: 'left',
    });

    this.datePicker = $(this.selector).data('daterangepicker');
    this.$datePicker = this.datePicker.container[0] as HTMLElement;

    // Add the event listeners.
    $(this.selector).on('apply.daterangepicker', (event) => this.onDateApplied(event));
    $(this.selector).on('show.daterangepicker', (event) => this.onDatePickerShown(event));
  }

  private onWindowResize(): void {
    if (window.innerWidth < 1200 && this.isInitialized) {
      this.isInitialized = false;
      this.domModified = false;

      this.datePicker.remove();
    }

    if (window.innerWidth >= 1200 && !this.isInitialized) {
      this.initialize();
    }
  }

  private onButtonClicked(): void {
    if (window.innerWidth >= 1200) {
      return;
    }

    if (this.$inputDateStart.value.length) {
      const [ startDay, startMonth, startYear ] = this.$inputDateStart.value.split('/');

      this.$drawerInputDateStartShadow.value = `${startYear}-${startMonth}-${startDay}`;
      this.$drawerInputDateStart.value = this.$inputDateStart.value;
    } else {
      this.$drawerInputDateStartShadow.value = '';
      this.$drawerInputDateStart.value = '';
    }

    if (this.$inputTimeStart.value.length) {
      this.$drawerInputTimeStartShadow.value = this.$inputTimeStart.value;
      this.$drawerInputTimeStart.value = this.$inputTimeStart.value;
    } else {
      this.$drawerInputTimeStartShadow.value = '';
      this.$drawerInputTimeStart.value = '';
    }

    if (this.$inputDateEnd.value.length) {
      const [ endDay, endMonth, endYear ] = this.$inputDateEnd.value.split('/');

      this.$drawerInputDateEndShadow.value = `${endYear}-${endMonth}-${endDay}`;
      this.$drawerInputDateEnd.value = this.$inputDateEnd.value;
    } else {
      this.$drawerInputDateEndShadow.value = '';
      this.$drawerInputDateEnd.value = '';
    }

    if (this.$inputTimeEnd.value.length) {
      this.$drawerInputTimeEndShadow.value = this.$inputTimeEnd.value;
      this.$drawerInputTimeEnd.value = this.$inputTimeEnd.value;
    } else {
      this.$drawerInputTimeEndShadow.value = '';
      this.$drawerInputTimeEnd.value = '';
    }

    this.$drawer.style.display = 'block';

    setTimeout(() => {
      [].slice.call(this.$drawer.querySelectorAll('input[data-shadow-input]')).forEach(($input: HTMLInputElement) => {
        const $shadow = this.$drawer.querySelector(`input${$input.getAttribute('data-shadow-input')}`) as HTMLInputElement;

        $shadow.style.height = `${$input.clientHeight}px`;
        $shadow.style.width = `${$input.clientWidth}px`;
        $shadow.style.left = `${$input.offsetLeft}px`;
        $shadow.style.top = `${$input.offsetTop}px`;
      });
    }, 10);
  }

  private onDrawerSubmitButtonClicked(event) {
    event.preventDefault();

    this.$drawerForm.classList.add('was-validated');

    if (!this.$drawerForm.checkValidity()) {
      event.stopPropagation();

      return;
    }

    const [ startDay, startMonth, startYear ] = this.$drawerInputDateStart.value.split('/');
    const [ startHour, startMinute ] = this.$drawerInputTimeStart.value.split(':');

    const [ endDay, endMonth, endYear ] = this.$drawerInputDateEnd.value.split('/');
    const [ endHour, endMinute ] = this.$drawerInputTimeEnd.value.split(':');

    const startDate = moment.utc(`${startYear}-${startMonth}-${startDay}T${startHour}:${startMinute}:00Z`);
    const endDate = moment.utc(`${endYear}-${endMonth}-${endDay}T${endHour}:${endMinute}:00Z`);

    this.$button.innerHTML = `<span><span>${startDate.format('D MMMM YYYY H:mm')}</span> <span class="d-none d-md-inline-block">-</span> <span>${endDate.format('D MMMM YYYY H:mm')}</span></span>`;

    this.$inputDateStart.value = this.$drawerInputDateStart.value;
    this.$inputTimeStart.value = this.$drawerInputTimeStart.value;
    this.$inputDateEnd.value = this.$drawerInputDateEnd.value;
    this.$inputTimeEnd.value = this.$drawerInputTimeEnd.value;

    this.$drawerForm.classList.remove('was-validated');
    this.$drawer.style.display = 'none';
  }

  private onDrawerCloseButtonClicked(event) {
    event.preventDefault();

    this.$drawerForm.classList.remove('was-validated');
    this.$drawer.style.display = 'none';
  }

  private onDatePickerShown(event): void {
    this.$datePicker.style.display = 'flex';

    if (!this.domModified) {
      this.domModified = true;

      // Modify the DOM of the date picker.
      const $outerWrapper = document.querySelector('.tc-daterangepicker').cloneNode(true) as HTMLElement;
      const $calendars = $outerWrapper.querySelector('.tc-daterangepicker-calendars');

      $calendars.appendChild(this.$datePicker.querySelector('.drp-calendar.left'));
      $calendars.appendChild(this.$datePicker.querySelector('.drp-calendar.right'));

      this.$pickerInputDateStart = $outerWrapper.querySelector('.tc-daterangepicker-input.is-start .tc-daterangepicker-input__date .form-control');
      this.$pickerInputTimeStart = $outerWrapper.querySelector('.tc-daterangepicker-input.is-start .tc-daterangepicker-input__time');
      this.$pickerInputDateEnd = $outerWrapper.querySelector('.tc-daterangepicker-input.is-end .tc-daterangepicker-input__date .form-control');
      this.$pickerInputTimeEnd = $outerWrapper.querySelector('.tc-daterangepicker-input.is-end .tc-daterangepicker-input__time');

      [].slice.call($outerWrapper.querySelectorAll('.tc-daterangepicker-input')).forEach(($input: HTMLElement) => {
        $input.querySelector('.tc-daterangepicker-input__date .form-control').addEventListener('blur', (event) => this.onDateInputBlurred(event, $input));
        $input.querySelector('.tc-daterangepicker-input__time').addEventListener('blur', (event) => this.onTimeInputBlurred(event, $input));
        $input.querySelector('.btn').addEventListener('click', (event: MouseEvent) => this.onDateDirectionButtonClicked(event));
      });

      if (!window.matchMedia('( pointer: coarse )').matches) {
        $($outerWrapper).find('.tc-daterangepicker-input__date .form-control').inputmask('datetime', {
          clearMaskOnLostFocus: false,
          placeholder: 'DD/MM/YYYY',
          inputFormat: 'dd/mm/yyyy',
          insertMode: true,
          alias: 'datetime',
        });

        $($outerWrapper).find('.tc-daterangepicker-input__time').inputmask('datetime', {
          clearMaskOnLostFocus: false,
          placeholder: 'HH:MM',
          inputFormat: 'HH:MM',
          insertMode: true,
          hourFormat: 24,
          alias: 'datetime',
        });
      }

      this.$datePicker.appendChild($outerWrapper);

      this.updateDOMValues();

      // Override the default event handler for the range buttons.
      [].slice.call(this.$datePicker.querySelectorAll('.ranges li')).forEach(($range: HTMLElement) => {
        $range.addEventListener('click', (event) => this.onRangeButtonClicked(event));
      });
    }
  }

  private onDateApplied(event): void {
    this.updateDOMValues();

    // Ensure that the date picker stays open after a date is selected.
    this.datePicker.show();
  }

  private onRangeButtonClicked(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    const $ranges = this.$datePicker.querySelectorAll('.ranges li');
    const $range = event.target as HTMLElement;

    [].slice.call($ranges).forEach(($range) => {
      $range.classList.remove('active');
    });

    $range.classList.add('active');

    let range = $range.getAttribute('data-range-key').split(' ').pop().toLowerCase();

    if (range === 'today') {
      range = 'day';
    }

    this.datePicker.setStartDate(moment().startOf(range));
    this.datePicker.setEndDate(moment().endOf(range));

    this.updateDOMValues();
  }

  private onDateDirectionButtonClicked(event: MouseEvent): void {
    event.preventDefault();

    const functionName = (event.target as HTMLElement).classList.contains('is-previous') ? 'subtract' : 'add';
    let currentRange = undefined;

    [ 'day', 'week', 'month', 'year' ].forEach((range) => {
      if (
        moment(this.datePicker.startDate).isSame(moment(this.datePicker.startDate).startOf(range))
        && moment(this.datePicker.endDate).isSame(moment(this.datePicker.endDate).endOf(range))
      ) {
        currentRange = range;
      }
    });

    if (!currentRange) {
      return;
    }

    this.datePicker.startDate.set(this.datePicker.startDate[functionName](1, currentRange).startOf(currentRange));
    this.datePicker.endDate.set(this.datePicker.endDate[functionName](1, currentRange).endOf(currentRange));

    this.updateDOMValues();
  }

  private onDateInputBlurred(event, $input: HTMLElement): void {
    const $target = event.target as HTMLInputElement;

    const [ day, month, year ] = $target.value.split('/');
    const date = $input.classList.contains('is-start') ? 'startDate' : 'endDate';

    this.datePicker[date].set({
      month: parseInt(month) - 1,
      year: parseInt(year),
      date: parseInt(day),
    });

    this.updateDOMValues();
  }

  private onTimeInputBlurred(event, $input: HTMLElement): void {
    const $target = event.target as HTMLInputElement;

    if ($input.classList.contains('is-start')) {
      this.$inputTimeStart.value = $target.value;
    } else {
      this.$inputTimeEnd.value = $target.value;
    }

    this.updateDOMValues();
  }

  private updateDOMValues(): void {
    if (window.innerWidth >= 1200) {
      const { startDate, endDate } = this.datePicker;
      const timeStart = this.$inputTimeStart.value;
      const timeEnd = this.$inputTimeEnd.value;

      this.$button.innerHTML = `<span><span>${startDate.format('D MMMM YYYY')} ${timeStart}</span> <span class="d-none d-md-inline-block">-</span> <span>${endDate.format('D MMMM YYYY')} ${timeEnd}</span></span>`;

      this.$inputDateStart.value = this.$pickerInputDateStart.value = startDate.format('DD/MM/YYYY');
      this.$pickerInputTimeStart.value = timeStart;

      this.$inputDateEnd.value = this.$pickerInputDateEnd.value = endDate.format('DD/MM/YYYY');
      this.$pickerInputTimeEnd.value = timeEnd;

      this.datePicker.updateElement();
      this.datePicker.updateView();
    }
  }
};
